import { Box, Heading, SimpleGrid } from "@chakra-ui/react";
import LinkActionButton from "@modules/Layout/components/LinkActionButton";
import ResponsiveContainer from "@modules/Layout/components/ResponsiveContainer";
import React, { memo } from "react";
import { ReactMarkdown } from "react-markdown/lib/react-markdown";
import { IconWithContentCard } from "@types/support";
import { AboutCardHero } from "../styles";

interface Props {
  data: IconWithContentCard[];
  title: string;
}
const About: React.FC<Props> = ({ data, title }) => {
  return (
    <AboutCardHero>
      <Box py={10}>
        <ResponsiveContainer>
          <Box textAlign={{ md: "center" }} my={10}>
            <Heading as={"h3"}>{title}</Heading>
          </Box>
          <SimpleGrid
            columns={{ base: 1, lg: 3 }}
            spacing={{ base: 7, md: 14, lg: 20, xl: 40 }}
          >
            {data.map((item, index) => (
              <Box key={index}>
                <ReactMarkdown children={item.content.data.content} />

                <LinkActionButton action={item.action} />
              </Box>
            ))}
          </SimpleGrid>
        </ResponsiveContainer>
      </Box>
    </AboutCardHero>
  );
};

export default memo(About);
